import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'LC Waikiki',
  logo: { name: 'LC Waikiki', src: '/logo/lcwaikikicard.png' },
  portrait: { src: '/photo/portrait-serafettin-ozer.png', alt: 'Şerafettin Özer' },
  quote: [
    'Strategic prioritization has been a key focus for us since 2021. With varying maturity '
    + 'levels across our business units in retail, logistics, and e-commerce, alignment is '
    + 'crucial. Conducting the assessment with full transparency helps us stay on track and '
    + 'make informed decisions.',
    'We selected Digitopia over major consulting firms and Gartner for their flexible and '
    + 'collaborative approach. We needed a partner who could go beyond a rigid, mechanical '
    + 'process and provide in-depth insights tailored to our needs.',
    'From the very beginning, their openness to feedback and continuous improvement have '
    + 'been key factors in our partnership.',
  ],
  attribution: 'Şerafettin Özer, Chief Digital and Information Officer',
  story: 'lc-waikiki',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 5
